import { Injectable } from '@angular/core';
import { StorageService } from '@ebootis/utilities';
@Injectable({
  providedIn: 'root'
})
export class SearchLimitService {
  private m_searchLimitLists: Map<SearchType, number[]> = new Map();
  private readonly m_defaultSearchLimit: number[] = [50, 100, 250, 500];

  constructor(
    private storageService: StorageService
  ) { }

  getSetLimit(p_type: SearchType) {
    var limit = +this.storageService.getItem('session', 'searchLimit' + p_type.toString());
    var list = this.getLimitList(p_type);
    if (!limit || !list.includes(limit))
      return list[list.length - 1]
    else
      return limit;
  }

  getLimitList(p_type: SearchType): number[] {
    return this.m_searchLimitLists.has(p_type) ? this.m_searchLimitLists.get(p_type) : this.m_defaultSearchLimit
  }


  setLimit(p_type: SearchType, p_limit: number) {
    this.storageService.setItem('session', 'searchLimit' + p_type.toString(), p_limit.toString());
  }

  setLimitList(p_type: SearchType, p_limits: number[]) {
    this.m_searchLimitLists.set(p_type, p_limits);
  }


  resetLimitList(p_type: SearchType) {
    this.m_searchLimitLists.set(p_type, this.m_defaultSearchLimit);
  }



}


export enum SearchType {
  CUSTOMER,
  ORDER
}
